import { messages, Messages } from './messages';

type Leaves<T> = T extends string
  ? ''
  : {
      [K in keyof T]: `${K & string}${Leaves<T[K]> extends '' ? '' : `.${Leaves<T[K]>}`}`;
    }[keyof T];

export type MessageKey = Leaves<Messages>;

export function t(key: MessageKey, vars?: Record<string, string | number>): string {
  let value: unknown = messages;
  for (const part of (key as string).split('.')) {
    if (typeof value !== 'object' || value === null) break;
    value = (value as Record<string, unknown>)[part];
  }
  if (typeof value !== 'string') {
    throw new Error(`Invalid message key: ${key}`);
  }
  if (!vars) return value;
  return value.replace(/\{(\w+)\}/g, (_match, name: string) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : `{${name}}`,
  );
}
